import React from 'react'
import Switch from 'react-switch'

function RelevantToggle({
  toggleShowingOnlyRelevantChapters,
  shouldOnlyShowRelevants
}) {
  return (
    <div className="switch-relevant">
      <span className="switch-relevant__text">
        Chapters relevant to your pathway
      </span>
      <Switch
        onChange={() => {
          toggleShowingOnlyRelevantChapters()
        }}
        checked={shouldOnlyShowRelevants}
        uncheckedIcon={false}
        height={25}
        width={35}
        checkedIcon={false}
        onColor="#3397db"
        id="material-switch"
      />
    </div>
  )
}
export default RelevantToggle
